import { render, staticRenderFns } from "./statements-create-form.component.vue?vue&type=template&id=5750d934&scoped=true"
import script from "./statements-create-form.component.vue?vue&type=script&lang=js"
export * from "./statements-create-form.component.vue?vue&type=script&lang=js"
import style0 from "./statements-create-form.component.vue?vue&type=style&index=0&id=5750d934&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5750d934",
  null
  
)

export default component.exports